export default __webpack_public_path__ + "static/media/whatsapp.96f9fdac.svg";